import { DogIcon, ImageCircle } from '$components'
import { PetRoutePaths } from '../../routes/protected'
import { QueryParams, Router } from '$utils/router'
import { Text } from '$components'
import { Link } from 'react-router-dom'

export type PetCellProps = {
  data: {
    id: number
    name: string
    image?: string
  }
  query?: QueryParams
}

export function PetCell({ data, query }: PetCellProps) {
  return (
    <Link
      to={
        Router.buildRoute(Router.getRoute(PetRoutePaths.PetsView, { id: data.id.toString() }),
          PetRoutePaths.PetsDetails,
          query,
        )}
      onClick={(e) => e.stopPropagation()}
      className="relative z-[2] flex gap-2 items-center border border-gray-100 w-fit rounded-full py-1 pl-1 pr-5 hover:border-indigo-400 bg-white transition-colors"
    >
      {data.image
        ? (
          <ImageCircle
            image={data.image}
            size="md"
          />
        )
        : (
          <div className="size-7 shrink-0 rounded-full flex items-center justify-center bg-gray-100">
            <DogIcon className="text-gray-400 size-4" />
          </div>
        )}

      <Text className="text-sm text-nowrap truncate max-w-32">
        {data.name}
      </Text>
    </Link>
  )
}
